module.exports = "pegasus_template/assets/frame-large-twitter.png";